import React from 'react';
import { SKILL_GRADIENT_PRESETS } from '../../utils/skillBrandGradients';

/**
 * Definiciones SVG globales para `fill: url(#skill-grad-{key})` en iconos de skills.
 * Rotación suave del degradado (SMIL); el texto usa animación CSS aparte.
 */
const SkillGradientDefs: React.FC = () => {
  return (
    <svg
      width="0"
      height="0"
      aria-hidden
      focusable="false"
      style={{ position: 'absolute', overflow: 'hidden' }}
    >
      <defs>
        {Object.entries(SKILL_GRADIENT_PRESETS).map(([key, preset]) => {
          const n = preset.stops.length;
          return (
            <linearGradient
              key={key}
              id={`skill-grad-${key}`}
              gradientUnits="userSpaceOnUse"
              x1="0"
              y1="0"
              x2="24"
              y2="24"
            >
              {preset.stops.map((c, i) => (
                <stop
                  key={`${key}-${i}`}
                  offset={`${(i / Math.max(1, n - 1)) * 100}%`}
                  stopColor={c}
                />
              ))}
              {preset.rotateSvg ? (
                <animateTransform
                  attributeName="gradientTransform"
                  type="rotate"
                  from="0 12 12"
                  to="360 12 12"
                  dur={`${preset.svgRotateSec ?? 22}s`}
                  repeatCount="indefinite"
                />
              ) : null}
            </linearGradient>
          );
        })}
      </defs>
    </svg>
  );
};

export default SkillGradientDefs;
